<template>
    <v-panel :class="theme.appBar">
        <div v-padding.left="2" v-padding.right="2">
            <v-row align-items="center">
                <v-col xs="6">
                    <balance />
                </v-col>
                <v-col v-text-align.right>
                    <company-menu />
                </v-col>
            </v-row>
        </div>
    </v-panel>
</template>
<script>
import Balance from './BalanceContainer';
import CompanyMenu from './CompanyMenuContainer';
import theme from './theme';

export default {
    name: 'app-bar',
    props: {
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    components: {
        Balance,
        CompanyMenu,
    }
}
</script>



// WEBPACK FOOTER //
// AppBar.vue?6952febf